module.exports = __webpack_public_path__ + "img/Druid-tauren-m-60.2fe0b63a.gif";